import { render, staticRenderFns } from "./BotDetection.vue?vue&type=template&id=f4f14af2&"
import script from "./BotDetection.vue?vue&type=script&lang=js&"
export * from "./BotDetection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports